<template>
  <div class="cyber-modal-overlay" v-if="visible" @click="handleOverlayClick">
    <div class="cyber-modal phone-broadcast-modal" @click.stop>
      <div class="decorative-corner top-left"></div>
      <div class="decorative-corner top-right"></div>
      <div class="decorative-corner bottom-left"></div>
      <div class="decorative-corner bottom-right"></div>

      <div class="modal-header">
        <div class="terminal-prompt">
          <span class="prompt-symbol">></span>
          <span class="prompt-text">手机转播配置</span>
        </div>
        <button class="close-button" @click="close">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="4" y1="4" x2="12" y2="12"></line>
            <line x1="12" y1="4" x2="4" y2="12"></line>
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <div class="phone-config-form">
          <div class="config-item">
            <span class="config-label">服务器地址</span>
            <input type="text" class="config-input" v-model="localConfig.serverUrl" placeholder="启动后自动显示" disabled>
          </div>
          
          <div class="config-item">
            <span class="config-label">端口</span>
            <input type="text" class="config-input" v-model="localConfig.port" placeholder="例如：8080" :disabled="localConfig.enabled">
          </div>

          <div class="config-item toggle-item">
            <span class="config-label">启用转播</span>
            <label class="cyber-switch">
              <input type="checkbox" v-model="localConfig.enabled" @change="handleEnabledChange">
              <span class="switch-track">
                <span class="switch-thumb"></span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showToast } from '@/utils/function';

export default {
  name: 'PhoneBroadcastModal',
  inject:["eSend"],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => ({
        enabled: false,
        serverUrl: '',
        port: '1935',
      })
    }
  },
  data() {
    return {
      localConfig: {}
    }
  },
  watch: {
    config: {
      handler(newVal) {
        this.localConfig = { ...newVal }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },

    handleOverlayClick() {
      this.close()
    },
    handleEnabledChange() {
      // 当启用转播时，自动填充服务器地址
      if (this.localConfig.enabled) {
        if (!this.localConfig.serverUrl) {
          this.localConfig.serverUrl = this.getLocalIPAddress();
        }
        this.eSend("start_rtmp",{

        })
        showToast('手机转播已启用', 'success');
      } else {
        showToast('手机转播已关闭', 'info');
      }
    },
    getLocalIPAddress() {
      // 获取本机 IP 地址 - 这里生成一个示例 IP
      return '192.168.1.' + Math.floor(Math.random() * 255);
    }
  }
}
</script>

<style scoped>

</style>
